export default __webpack_public_path__ + "static/media/batik3.96bcd69f.webp";